import { ref } from 'vue'

// 전역 상태
export const alertState = ref({
  visible: false,
  message: '',
  type: 'info',
  confirmText: '확인',
  onConfirm: null
})

// 알럿 표시 함수
export const showAlert = (message, options = {}) => {
  return new Promise((resolve) => {
    alertState.value = {
      visible: true,
      message,
      type: options.type || 'info',
      confirmText: options.confirmText || '확인',
      onConfirm: () => {
        alertState.value.visible = false
        resolve(true)
      }
    }
  })
}

// 편의 함수들
export const showSuccess = (message, confirmText = '확인') => {
  return showAlert(message, { type: 'success', confirmText })
}

export const showError = (message, confirmText = '확인') => {
  return showAlert(message, { type: 'error', confirmText })
}

export const showWarning = (message, confirmText = '확인') => {
  return showAlert(message, { type: 'warning', confirmText })
}

export const showInfo = (message, confirmText = '확인') => {
  return showAlert(message, { type: 'info', confirmText })
}

// alert() 대체 함수 객체
export const customAlert = {
  show: showInfo,
  success: showSuccess,
  error: showError,
  warning: showWarning,
  info: showInfo
}
